import * as React from "react";
import { useScrollLock } from "../../hooks";
import { SearchBox } from "../SearchBox/SearchBox";
import { UniversalLink } from "../UniversalLink/UniversalLink";
import { LoginMenu } from "./LoginMenu";
import { Logo, LogoLink, NavItems, NavItem, NavIcon, NavControls, MobileMenuIcon, MobileMenu, CloseIcon, MobileLogo, MobileMenuItem } from "./navbar.elements";
import { NavBarWrapper } from "./navbar.elements";
export default function UserNavBar(a) {
  var _React$useState = React.useState(!1),
      b = _React$useState[0],
      c = _React$useState[1],
      d = function d() {
    return c(!1);
  };

  useScrollLock(b), React.useEffect(function () {
    d();
  }, [a.location.pathname]);

  var _a$items = a.items,
      k = _a$items === void 0 ? [] : _a$items,
      e = a.logo,
      _a$href = a.href,
      l = _a$href === void 0 ? "/" : _a$href,
      f = a.altText,
      g = a.pathPrefix,
      h = a.standalone,
      i = a.location,
      j = a.className,
      m = function m(b, c) {
    return a.sidebarName === b.activateWithSidebar || b.link === i.pathname && !c.some(function (b) {
      return b.activateWithSidebar === a.sidebarName;
    });
  };

  return /*#__PURE__*/React.createElement(NavBarWrapper, {
    className: j,
    standalone: h,
    id: "navbar"
  }, /*#__PURE__*/React.createElement(LogoLink, {
    to: l
  }, /*#__PURE__*/React.createElement(Logo, {
    src: e,
    alt: f
  })), /*#__PURE__*/React.createElement(NavItems, null, k.map(function (a, b) {
    return "search" === a.type ? /*#__PURE__*/React.createElement(SearchBox, {
      pathPrefix: g,
      key: b,
      location: i
    }) : /*#__PURE__*/React.createElement(NavItem, {
      key: b,
      "data-cy": a.label,
      active: m(a, k)
    }, /*#__PURE__*/React.createElement(UniversalLink, {
      to: a.link,
      target: a.target,
      external: a.external
    }, /*#__PURE__*/React.createElement(React.Fragment, null, a.icon ? /*#__PURE__*/React.createElement(NavIcon, {
      url: a.icon
    }) : null, /*#__PURE__*/React.createElement("span", {
      style: {
        verticalAlign: "middle"
      }
    }, a.label))));
  }), /*#__PURE__*/React.createElement(LoginMenu, null)), /*#__PURE__*/React.createElement(NavControls, null, /*#__PURE__*/React.createElement(MobileMenuIcon, {
    onClick: function onClick() {
      return c(!b);
    }
  })), /*#__PURE__*/React.createElement(MobileMenu, {
    isShown: b
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: d
  }), /*#__PURE__*/React.createElement(UniversalLink, {
    to: l
  }, /*#__PURE__*/React.createElement(MobileLogo, {
    src: e,
    alt: f
  })), k.map(function (a, c) {
    return "search" === a.type ? b && /*#__PURE__*/React.createElement(SearchBox, {
      pathPrefix: g,
      key: c
    }) || null : /*#__PURE__*/React.createElement(MobileMenuItem, {
      key: "mobile-menu-" + c,
      onClick: d
    }, /*#__PURE__*/React.createElement(UniversalLink, {
      to: a.link,
      target: a.target,
      external: a.external
    }, a.label));
  }), /*#__PURE__*/React.createElement(LoginMenu, {
    mobile: !0
  })));
}